import React from "react";
interface LogoProps {
  inverted?: boolean;
}
export function Logo({
  inverted = false
}: LogoProps) {
  const text = inverted ? "text-white" : "text-ink";
  return <span className="inline-flex items-center gap-2.5" data-id="element-243" data-mp="8uwbl00h02yb">
      <svg width="30" height="30" viewBox="0 0 40 40" aria-hidden="true" data-id="element-244" data-mp="3qaw22qrajw9s">
        <circle cx="20" cy="20" r="17" fill="none" stroke={inverted ? "#D9C08A" : "#A8842F"} strokeWidth="2.2" strokeDasharray="80 27" transform="rotate(120 20 20)" data-id="element-245" data-mp="3v7wcfdv6bl6p" />
        <path d="M20 5 L22.2 17.8 L35 20 L22.2 22.2 L20 35 L17.8 22.2 L5 20 L17.8 17.8 Z" fill={inverted ? "#FFFFFF" : "#151515"} data-id="element-246" data-mp="rrxkux124p82" />
        <path d="M20 11 L21.2 18.8 L29 20 L21.2 21.2 L20 29 L18.8 21.2 L11 20 L18.8 18.8 Z" fill={inverted ? "#D9C08A" : "#A8842F"} transform="rotate(45 20 20)" data-id="element-247" data-mp="dsxv1m1t64ab" />
      </svg>
      <span className="flex flex-col leading-none" data-id="element-248" data-mp="2yif04g1or0w1">
        <span className={`text-[14px] font-semibold tracking-[0.16em] transition-colors duration-200 ${text}`} data-id="element-249" data-mp="2ygu2uinzl3uh">KOERS DESIGN</span>
        <span className={`mt-1 text-[8.5px] font-medium tracking-[0.26em] ${inverted ? "text-gold-soft" : "text-gold"}`} data-id="element-250" data-mp="32hnr5d5ccknw">PRINTEN EN GRAVEREN</span>
      </span>
    </span>;
}